export function registerGlobalComponents(app) {
  const components = import.meta.glob('@/components/commons/**/*.vue', {
    eager: true,
  });

  Object.entries(components).forEach(([path, module]) => {
    const componentName = path
      .split('/')
      .pop()
      .replace(/\.\w+$/, '');

    app.component(componentName, module.default);
  });
}
